import React from "react";
import { Table } from "semantic-ui-react";
import PropTypes from "prop-types";
export const DatatableRow = (props) => (

  <Table.Row>
    <Table.Cell>
      {props.list.user_type != "main" ? (<>
        <span>
          <a
            onClick={() => props.deleteCompletedChat(props.list.id)}
            title="Delete"
            className="btn btn-icon gray"
          >
            <i className="la la-trash"></i>
          </a>{" "}
        </span>
        <span>
          <a
            onClick={() => props.editMember(props.list.id)}
            title="Edit"
            className="btn btn-icon gray"
          >
            <i className="la la-edit blue"></i>
          </a>{" "}
        </span>
      </>
      ) : (
        ""
      )}
    </Table.Cell>
    <Table.Cell>
       {props.list.notification_type == 1 ? "All notifications" : "Schedule based"}
    </Table.Cell>
    <Table.Cell>
      {props.list.name}
    </Table.Cell>
    <Table.Cell>
      {props.list.emailphone}
    </Table.Cell>
    <Table.Cell key={props.list?.id}>
      <div className="" style={{ display: 'flex', columnGap: 10, alignItems: 'center' }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <input
            disabled
            checked={props.list.notify_via.includes('email') || (!props.list.notify_via.length && props.list.email != '')}
            type="checkbox"
            readOnly
            style={{ margin: 0 }}
          /> Email
        </span>
        {(!props.isPLG || props.ai_voice_type === 'inbound') && (
        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <input
            disabled
            checked={props.list.notify_via.includes('text') || (!props.list.notify_via.length && props.list.phone != '')}
            type="checkbox"
            readOnly
            style={{ margin: 0 }}
          /> Text
        </span>
        )}
        {!props.isPLG && (
        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <input
            disabled
            checked={props.list.notify_via.includes('phonecall')}
            type="checkbox"
            readOnly
            style={{ margin: 0 }}
          /> Phone Call
        </span>
        )}
      </div>
    </Table.Cell>
      <Table.Cell>
      {props.list.user_notification_values}
    </Table.Cell>
  </Table.Row>
);

DatatableRow.propTypes = {
  list: PropTypes.object.isRequired,
};
